import * as React from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import * as _ from 'lodash'


import { copyObject, formatPhoneNumberUS, phoneFormat } from '../../../../utils';


import NumberFormatValidate from '../../../../components/NumberFormatValidate';
import { isEmail } from '../../../../utils/validator';
import { removePrefixUS } from '../../../../utils/utilsT'
import { ContactPersonT, JobT } from '../../../../types/Job';

export interface IContactPersonProps {
    job: JobT
    contactMode: "call" | "email" | "text" | string
    onChangeContact(contact: ContactPersonT): void
    selectedContact: ContactPersonT | null
}

export const initContactPerson: ContactPersonT = {
    name: "",
    phone: null,
    email: "",
    contactMethod: "text"
}

const ContactPerson: React.FC<IContactPersonProps> = ({ job, contactMode, onChangeContact, selectedContact }) => {
    const [contactFields, setContactFields] = React.useState(copyObject(initContactPerson));
    const [selecteContact, setSelecteContact] = React.useState(null);
    const [contacts, setContacts] = React.useState([])
    const [showFormAdd, setShowFormAdd] = React.useState(false);

    React.useEffect(() => {
        if (selectedContact != selecteContact) {
            setSelecteContact(selectedContact)
        }
    }, [selectedContact])


    React.useEffect(() => {
        setContacts(job.contactPerson)
    }, [job.contactPerson])



    React.useEffect(() => {
        console.log("cloneContacts->job.client", job.client)
        const contactClient: ContactPersonT = {
            name: `${job.client.firstName} ${job.client.lastName}`,
            phone: Number(`${job?.client?.phone}`),
            email: job.client.email,
            contactMethod: "text",
            isClient: true
        }

        addContact(contactClient, contactMode)

        if (selecteContact == null) {
            //  setSelecteContact(contectClient)
            onChangeContact(contactClient)
        }
    }, [job.client])

    const updateContactFields = (key: string, value: any) => {
        const cloneContact = copyObject(contactFields)
        cloneContact[key] = value
        setContactFields(cloneContact)
    }

    const renderContacts = () => {
        return contacts.map((item, index) => {
            return (
                <div className="col-md-4 " key={index}
                    style={{ padding: 2, backgroundColor: isSelectedContact(item, selecteContact) ? "#eee" : "#fff", cursor: "pointer" }}
                    onClick={() => {

                        setSelecteContact(item)
                        onChangeContact(item)
                    }}>
                    <span>{item.name}</span>
                    {/* <span>{item.phone}</span> */}
                    {/* <span>{item.email}</span> */}
                </div>
            )
        })
    }



    const isSelectedContact = (contact: ContactPersonT, _selectedContact: ContactPersonT) => {

        if (_selectedContact) {
            return contact.name == _selectedContact.name && contact.phone == _selectedContact.phone;
        }
        return false;
    }


    const contactExists = (_contacts: Array<ContactPersonT>, contact: ContactPersonT) => {
        return _contacts.find((x) => (x.name == contact.name || x.phone == contact.phone))
    }

    const addContact = (contact: ContactPersonT, contactMode) => {
        const cloneContacts = copyObject(contacts)
        console.log("cloneContacts", cloneContacts)

        if (!contactExists(cloneContacts, contact)) {
            cloneContacts.push(contact)
            setContacts(cloneContacts)
        } else if (contact?.isClient) {
            /**
             * if change client information should be reflect in contact 
             */
            const findIndex = cloneContacts.findIndex((x) => (x.name == contact.name || x.phone == contact.phone))
            if (findIndex >= 0) {
                cloneContacts[findIndex] = contact
                setContacts(cloneContacts)
                setSelecteContact(null)
            }
        }
    }


    const validateFields = (contact: ContactPersonT, contactMode) => {
        const cloneContacts = copyObject(contacts)
        // const typeInput = contactMode == "email" ? "email" : "phone"
        if (contact.name != ""
            && ((contact.phone != null && validatePhone(contact.phone))
                && (contact.email != null && isEmail(contact.email))) && !contactExists(cloneContacts, contact)) {
            return true
        }
        return false;

    }


    const validatePhone = (phone) => {
        return _.isNumber(phone) && phone.toString().length == 10
    }

    return (
        <div>
            <Row className="align-items-center">
                {(contactMode == "call" || contactMode == "text") && <Col md="4" xs="auto">

                    <span className="text-primary">{`${selecteContact && selecteContact.phone ? `${removePrefixUS(formatPhoneNumberUS(`${selecteContact.phone}`))}` : ""}`}</span>
                </Col>}
                {contactMode == "email" && <Col xs="auto">

                    <span className="text-primary">{`${selecteContact && selecteContact.email ? selecteContact.email : ""}`}</span>
                </Col>}

            </Row>
            {/* <div className="list-group list-group-flush"> */}
            {renderContacts()}
            {/* </div> */}


            {showFormAdd && <Form className="col-md-4">
                <Form.Group controlId="contactName">
                    <Form.Control
                        value={`${contactFields.name}`}
                        className='input-material'
                        onChange={(event) => {
                            updateContactFields("name", event.target.value)
                            //setSelectedContact(null)
                        }}
                        placeholder="Name" />
                </Form.Group>

                <Form.Group controlId="contactPhone">
                    <NumberFormatValidate
                        customInput={Form.Control}
                        className="input-material"
                        type="text"
                        defaultValue={`${contactFields.phone}`}
                        value={`${contactFields.phone}`}
                        onValueChange={(values) => {
                            const { formattedValue, value, floatValue } = values;
                            updateContactFields("phone", floatValue)
                        }}
                        // maxLength={10}
                        // minLength={10}
                        mask="_"
                        customValidate={(floatValue) => {
                            return _.isNumber(floatValue) && floatValue.toString().length == 10
                        }}
                        placeholder="Number Phone"
                        format="+1 (###) ###-####"
                    // required={true}
                    // showError={false}
                    />

                </Form.Group>

                <Form.Group controlId="contactEmail">
                    <Form.Control
                        value={`${contactFields.email}`}
                        className='input-material'
                        onChange={(event) => {
                            updateContactFields("email", event.target.value)
                            // setSelectedContact(null)
                        }}
                        placeholder="Email"
                    />
                </Form.Group>

                {contactFields.name != "" && <Row><Col xs="auto">
                    <Button type="button" className="mb-2" onClick={(event) => {
                        if (validateFields(contactFields, contactMode)) {
                            addContact(contactFields, contactMode)
                            setContactFields(copyObject(initContactPerson))
                            setShowFormAdd(false);
                        }

                        // clear current contact

                    }}>
                        <i className="fa fa-plus" /> Add</Button>
                </Col> </Row>}
            </Form>}
            {/* {!showFormAdd && <Form.Row>
                <Col xs="auto">
                    <Button type="button" variant="light" className="mb-2" onClick={(event) => { setShowFormAdd(true) }}>
                        Add New Contact</Button>
                </Col>
            </Form.Row>} */}
        </div>
    );
}

export default ContactPerson;

export { ContactPerson };